import { css } from 'reakit/styled';
import { palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
var Tabs = {
  base: css(["border-bottom:none;margin-bottom:1px;"]),
  Tab: {
    base: css(["height:50px;text-transform:uppercase;"]),
    active: css(["background-color:transparent;"]),
    hover: css(["background-color:transparent;border-bottom:none;color:", ";"], palette('primary'))
  }
};
export default Tabs;